import { Ajax } from '@newrelic/browser-agent/features/ajax';
import { GenericEvents } from '@newrelic/browser-agent/features/generic_events';
import { JSErrors } from '@newrelic/browser-agent/features/jserrors';
import { Metrics } from '@newrelic/browser-agent/features/metrics';
import { PageViewEvent } from '@newrelic/browser-agent/features/page_view_event';
import { SessionTrace } from '@newrelic/browser-agent/features/session_trace';
import { Spa } from '@newrelic/browser-agent/features/spa';

// Populate using values in copy-paste JavaScript snippet.
const options = {
  init: {
    distributed_tracing: { enabled: true },
    privacy: { cookies_enabled: true },
    ajax: { deny_list: ['bam.nr-data.net'] },
  }, // NREUM.init
  info: {
    beacon: 'bam.nr-data.net',
    errorBeacon: 'bam.nr-data.net',
    licenseKey: process.env.REACT_APP_NR_LICENSE_KEY,
    applicationID: process.env.REACT_APP_NR_AGENT_AND_APPLICATION_ID,
    sa: 1,
  }, // NREUM.info
  loader_config: {
    accountID: process.env.REACT_APP_NR_ACCOUNT_ID,
    trustKey: process.env.REACT_APP_NR_ACCOUNT_ID,
    agentID: process.env.REACT_APP_NR_AGENT_AND_APPLICATION_ID,
    licenseKey: process.env.REACT_APP_NR_LICENSE_KEY,
    applicationID: process.env.REACT_APP_NR_AGENT_AND_APPLICATION_ID,
  }, // NREUM.loader_config
} as const;

const NewRelicConfig = {
  ...options,
  features: [
    Metrics,
    Ajax,
    JSErrors,
    PageViewEvent,
    GenericEvents,
    SessionTrace,
    Spa,
  ],
};

export default NewRelicConfig;
